import React from "react";
import "bootstrap/dist/css/bootstrap.css";

import "./App.css";
import Layout from "./Layout/Layout"

// React Notification


function App() {
  return (
   <Layout />
  );
}

export default App;
